import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

// Types
import { UpdateAiReportType } from 'Shared/types/UpdateAiReportType.type';

// Hooks
import { useToggle } from 'Shared/utils/hooks';

// Selectors
import { getUpdateAiReportsByDraft } from 'Shared/selectors/UpdateAiSettings.selectors';

// Actions
import { fetchUpdateAiReports } from 'Shared/actions/UpdateAiReports.actions';

export const useUpdateAiReports = () => {
  const dispatch = useDispatch();

  const [isFetching, toggleIsFetching] = useToggle(true);

  const draftReports: UpdateAiReportType[] =
    useSelector(state => getUpdateAiReportsByDraft(state, { draft: true }))
      ?.valueSeq()
      .toJS() || [];
  const notDraftReports: UpdateAiReportType[] =
    useSelector(state => getUpdateAiReportsByDraft(state, { draft: false }))
      ?.valueSeq()
      .toJS() || [];
  const allReports: UpdateAiReportType[] = [...draftReports, ...notDraftReports];

  useEffect(() => {
    dispatch(fetchUpdateAiReports()).finally(() => {
      toggleIsFetching();
    });
  }, []);

  return {
    draftReports,
    notDraftReports,
    allReports,
    isFetching,
  };
};
